
export const checaFormatoSenha = senha => /[a-zA-Z]/.test(senha) && /[0-9]/.test(senha) && /\W|_/.test(senha) && senha.length > 7;

